import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InproviderPermmissionDirective } from './inprovider-permmission.directive';



@NgModule({
  declarations: [InproviderPermmissionDirective],
  imports: [
    CommonModule
  ],
  exports:[InproviderPermmissionDirective]
})
export class DirectivesModule { }
